var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.053,
    height: 17.053,
    viewBox: "0 0 17.053 17.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43090",
    "data-name": "Group 43090",
    transform: "translate(-1033 -2078.53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 8.526,
    cy: 8.526,
    r: 8.526,
    transform: "translate(1033 2078.53)",
    fill: "#26db00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31927",
    "data-name": "Path 31927",
    d: "M1149.006,6442.293l2.3,2.55,4.834-4.549",
    transform: "translate(-111.046 -4355.512)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseTick);
export default __webpack_public_path__ + "static/media/EllipseTick.10ad2f23c056ed9663204be4d6e9a637.svg";
export { ForwardRef as ReactComponent };